import AttachmentsList from '@app/components/AttachmentsList'
import PhotoStrip from '@app/components/PhotoStrip'
import { IAttachment } from '@app/models/Attachment'
import { AttachmentType } from '@app/models/enums'
import { List } from 'immutable'
import * as React from 'react'

interface ISimpleFilesViewProps {
  className?: string
  files: List<IAttachment>
  style?: React.CSSProperties
}

export default class SimpleFilesView extends React.PureComponent<
  ISimpleFilesViewProps
> {
  public render() {
    if (this.props.files.size === 0) {
      return (
        <div className={this.props.className} style={this.props.style}>
          No files
        </div>
      )
    }

    const photos: IAttachment[] = []
    const attachments: IAttachment[] = []

    this.props.files.toArray().forEach((file) => {
      if (
        file.type === AttachmentType.Photo ||
        file.type === AttachmentType.MainPhoto
      ) {
        photos.push(file)
      } else {
        attachments.push(file)
      }
    })

    return (
      <div className={this.props.className} style={this.props.style}>
        {photos.length > 0 && <PhotoStrip photos={List(photos)} />}
        {attachments.length > 0 && (
          <AttachmentsList
            attachments={List(attachments)}
            onChange={(e) => console.log(e)}
            noFilter
            noSort
          />
        )}
      </div>
    )
  }
}
